<template>
  <div class="misc-wrapper">
    <!-- <b-link class="brand-logo">
      <logo />
      <h2 class="brand-text text-primary ml-1">
        BrandMe
      </h2>
    </b-link> -->

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">
          {{$t('error.informTitle')}}
        </h2>
        <p class="mb-2">
          {{$t('error.informContent')}}
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          @click="loginRoute()"
        >
          {{$t('error.backhome')}}
          <b-spinner class="ml-1" small></b-spinner>
        </b-button>

        <!-- image -->
        <b-img
          fluid
          :src="downImg"
          alt="Error page"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { BButton, BImg, BSpinner } from 'bootstrap-vue'
// import Logo from '@/assets/images/logo/brandme_logo_gray.png'
export default {
  components: {
    // Logo,
    // BLink,
    BButton,
    BImg,
    BSpinner
  },
  data () {
    return {
      downImg: require('@/assets/images/pages/error.svg')
    }
  },
  methods: {
    loginRoute () {
      this.$router.push('/dashboard')
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
